import { forwardRef, type Ref, type SVGProps } from "react";
const IconHouseUserOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 10a4 4 0 0 0-4 4.04v.817a5.53 5.53 0 0 0 1.714 3.857l-1.143.252C9.834 19.606 8 20.977 8 22.57v2.286C8 25.488 8.512 26 9.143 26h13.714c.631 0 1.143-.512 1.143-1.143v-2.286c0-1.594-1.857-2.965-4.571-3.605l-1.183-.229a5.6 5.6 0 0 0 1.714-3.88v-.817A4 4 0 0 0 16 10"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17.2 1.9 10.09 9.5a2 2 0 0 1 .71 1.53V28a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V12.93a2 2 0 0 1 .71-1.53L14.8 1.9a2 2 0 0 1 2.4 0M6 12.93V28h20V12.93L16 3.52z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHouseUserOutlineSVG);
ForwardRef.displayName = "IconHouseUserOutline";
export { ForwardRef as IconHouseUserOutline };
